import { CROSS_JOBS } from '../../content'
import { anim, stagger } from '../../motion'
import { COLORS, Count } from '../../primitives'
import { Line, Words } from '../kit'

// Bento-Grid mit Kennzahlen, alles Beispieldaten
const SPREAD = [
  [52, 58, 61, 64, 70, 74, 79, 87],
  [55, 62, 66, 73, 80, 84, 88, 91],
  [48, 57, 61, 66, 70, 78, 84],
  [50, 55, 62, 66, 70, 82]
]
const avg = (xs) => Math.round(xs.reduce((s, v) => s + v, 0) / xs.length)

const tile = (i) => anim({ at: stagger(0.12, 0.05, 0.12, i), y: 60, s: 0.92 })

export default function CinData() {
  return (
    <div className='cin-pad cin-pad--top cin-data'>
      <div className='cin-row-between'>
        <h2 className='cin-title'>
          <Words
            text='Daten, die Entscheidungen leichter machen.'
            at={[0, 0.14]}
          />
        </h2>
        <Line at={[0.06, 0.12]} y={10} className='cin-sample'>
          Beispieldaten
        </Line>
      </div>

      <div className='cin-bento'>
        <div className='cin-tile cin-tile--blue cin-tile--wide' style={tile(0)}>
          <span>Talente eingeladen</span>
          <Count to={48} at={[0.16, 0.4]} className='cin-tile__num' />
        </div>
        <div className='cin-tile cin-tile--green' style={tile(1)}>
          <span>Abschlussquote</span>
          <Count
            to={85}
            at={[0.2, 0.44]}
            suffix={' %'}
            className='cin-tile__num'
          />
        </div>
        <div className='cin-tile' style={tile(2)}>
          <span>Ø Passung</span>
          <Count
            to={73}
            at={[0.24, 0.48]}
            suffix={' %'}
            className='cin-tile__num'
          />
        </div>
        <div className='cin-tile cin-tile--yellow' style={tile(3)}>
          <span>Kreuzmatches</span>
          <Count to={6} at={[0.28, 0.5]} className='cin-tile__num' />
        </div>
        <div className='cin-tile cin-tile--chart' style={tile(4)}>
          <span>Passung je Stelle</span>
          <div className='cin-spread'>
            {CROSS_JOBS.map((job, r) => (
              <div key={job} className='cin-spread__row'>
                <span className='cin-spread__job'>{job}</span>
                <div className='cin-spread__track'>
                  {SPREAD[r].map((v, i) => (
                    <i
                      key={i}
                      style={{
                        left: `${v}%`,
                        background: v >= 80 ? COLORS.green : COLORS.blue,
                        ...anim({
                          at: stagger(0.44 + r * 0.04, 0.012, 0.06, i),
                          y: -30,
                          s: 0.3
                        })
                      }}
                    />
                  ))}
                  <b
                    style={{
                      left: `${avg(SPREAD[r])}%`,
                      ...anim({ at: stagger(0.6, 0.03, 0.06, r), s: 0.2, y: 0 })
                    }}
                  />
                </div>
                <span className='cin-spread__avg'>
                  Ø {avg(SPREAD[r])}&nbsp;%
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
